import React from 'react';
import { TimeFrame } from 'models/ReportData';
import { formatSecToHourString, formatSecToMinString } from 'helpers/conversions';
import { ITopCardsProps } from './TopCardsContainer';
import { Box } from '@mui/material';
import { chartIcon, dashboardIcon, likeIcon, productionIcon } from '../Icons';
import TotalImpressionCardMobileDtg from '../TotatImpressionCardMobile';
import ProductionRateCardMobileDtg from '../ProductionRateCardMobileDtg';
import ProductivityCardMobileDtg from '../ProductivityCardMobileDtg';
import AvailabilityCardMobileDtg from '../AvailabilityCardMobileDtg';
import { styles } from './OverviewTopCard.styles';

const MobileDtgTopCards = (props: ITopCardsProps) => {
  const {
    timeframe,
    totalProduction,
    productionTrend,
    productionRate,
    productionRateTrend,
    loadingTime,
    loadingTimeTrend,
    darkImpressionsPercentage,
    darkImpressionsTrend,
    productivity,
    productivityChange,
    printingTime,
    printingTimeTrend,
    availability,
    availabilityTrend,
    errorDuration,
    errorDurationTrend,
    maintenanceDuration,
    maintenanceDurationTrend,
    selectedSystemGroup,
    selectedSystemGroupText,
    units,
    isProductionMode,
  } = props;
  const darkImpressionsValue =
    darkImpressionsPercentage !== undefined
      ? darkImpressionsPercentage * 100
      : darkImpressionsPercentage;
  const getTimeframeTextKey = () => {
    return timeframe && timeframe.includes('lastUpdate') ? 'last' : 'weekDay';
  };
  const changeTextPerPage = (timeframe: TimeFrame | '', text: string) => {
    if (timeframe && timeframe.includes('lastUpdate')) return text.replace('Average', 'Current');
    return text;
  };
  return (
    <>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <TotalImpressionCardMobileDtg
          value={totalProduction}
          units={units}
          icons={productionIcon(selectedSystemGroup)}
          description={selectedSystemGroupText.impression.description[getTimeframeTextKey()]}
          stats={productionTrend}
          statsDescription={selectedSystemGroupText.impression.statsDescription[getTimeframeTextKey()]}
          addedData={{
            upper: {
              unit: '%',
              value: darkImpressionsValue,
              description: selectedSystemGroupText.productionRate.lower,
              trend: darkImpressionsTrend,
            },
          }}
          cardName="totalProduction"
        />
      </Box>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <ProductionRateCardMobileDtg
          selectedSystemGroup={selectedSystemGroup}
          value={productionRate}
          units={units + '/h'}
          icons={dashboardIcon}
          description={
            isProductionMode
              ? selectedSystemGroupText.productionRate.descriptionProduction
              : selectedSystemGroupText.productionRate.description[getTimeframeTextKey()]
          }
          stats={productionRateTrend}
          statsDescription={
            selectedSystemGroupText.productionRate.statsDescription[getTimeframeTextKey()]
          }
          cardName="averageProductionRate"
        />
      </Box>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <ProductivityCardMobileDtg
          selectedSystemGroup={selectedSystemGroup}
          value={productivity}
          units={units + '/h'}
          icons={chartIcon}
          description={
            isProductionMode
              ? selectedSystemGroupText.utilization?.descriptionProduction
              : 'Productivity'
          }
          stats={productivityChange}
          statsDescription={
            selectedSystemGroupText.productionRate.statsDescription[getTimeframeTextKey()]
          }
          addedData={{
            upper: {
              unit: 'min',
              value: printingTime,
              description: 'Avg. Print Time',
              trend: printingTimeTrend,
              formatter: formatSecToMinString,
            },
            lower: {
              unit: 'sec/' + units,
              value: loadingTime,
              description: changeTextPerPage(timeframe, selectedSystemGroupText.productionRate.upper),
              trend: loadingTimeTrend,
            },
          }}
          cardName="productivity"
        />
      </Box>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <AvailabilityCardMobileDtg
          cardName="availability"
          value={availability}
          units={'%'}
          icons={likeIcon}
          isPercentage={true}
          description={
            isProductionMode
              ? selectedSystemGroupText.availability.descriptionProduction
              : selectedSystemGroupText.availability.description[getTimeframeTextKey()]
          }
          stats={availabilityTrend}
          statsDescription={
            selectedSystemGroupText.availability.statsDescription[getTimeframeTextKey()]
          }
          addedData={{
            upper: {
              unit: '',
              value: errorDuration,
              description: selectedSystemGroupText.availability.upper,
              trend: errorDurationTrend,
              formatter: formatSecToHourString,
            },
            lower: {
              value: maintenanceDuration,
              unit: '',
              description: selectedSystemGroupText.availability.lower,
              trend: maintenanceDurationTrend,
              formatter: formatSecToHourString,
            },
          }}
        />
      </Box>
    </>
  );
};

export default MobileDtgTopCards;
